var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparklingWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sparkling_water",
    transform: "matrix(0.3125,0,0,0.16,-335.625,360.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2,0,0,6.25,-654,-562.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,500,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.18617,0,-43.3035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350,205.116C350,205.116 301.447,226.874 250,205.116C213.572,189.71 188.177,186.934 160,188.255C112.258,190.493 68.024,222.439 60,238.838",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "13.7px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,100L140,400L260,400L300,100L100,100Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 674.172,
    cy: 235.828,
    r: 14.172,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,104.172)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 674.172,
    cy: 235.828,
    r: 14.172,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5,-14.8312)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 722.745,
    cy: 302.745,
    r: 22.745,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingWater);
export default __webpack_public_path__ + "static/media/sparkling_water.4aec2c82e74d58a2241bc540320330de.svg";
export { ForwardRef as ReactComponent };